import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import AppWrapper from "./App";
import "./App.css";

const rootElement = document.getElementById("root");

if (!rootElement) throw new Error("Root element not found");

const root = ReactDOM.createRoot(rootElement);

root.render(
	<BrowserRouter>
		<AppWrapper />
	</BrowserRouter>
);
